import { Carousel, Divider, Image } from "antd";
import React, { useContext } from "react";
import { AiOutlineWarning } from "react-icons/ai";
import { ItemInfoWrapper } from "../../container/Styles/Wrappers";
import { AppContext } from "../../context";
import { lng } from "../../library/language";
import Conditions from "./components/Conditions";

function RentacarInfo({ product, store }) {
  const info = useContext(AppContext);

  return (
    <ItemInfoWrapper>
      <div className="carousel-container">
        <Carousel>
          {/* for creatives */}
          {product?.videos?.length > 0 && (
            <iframe
              // width="460"
              height="300"
              src={product.videos[0]}
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
              style={{ zIndex: -100 }}
            ></iframe>
          )}
          {product.gen_files?.map((im, index) => (
            <Image alt={im.alt} src={im.url} key={index} />
          ))}
        </Carousel>
      </div>
      <div className="title" style={{ marginBottom: 10 }}>
        <h1 className="item-name">{product?.gen_name}</h1>
        {store?.name && <h2 className="item-parent">{lng(store?.name)}</h2>}
      </div>
      <div style={{ padding: 16 }}>
        <div
        // className="ahp-description"
        >
          {product?.gen_description[info.language]}
        </div>

        {product.gen_description_additional &&
          product.gen_description_additional[info.language] && (
            <>
              <Divider></Divider>
              <div
              // className="ahp-description-additional"
              >
                {product.gen_description_additional[info.language]}
              </div>
            </>
          )}

        {info?.rentacar?.typology ? (
          <div>
            <Divider></Divider>
            <div>
              <strong>
                {info.t("conditions")} - {info.t(info.rentacar?.typology)}
              </strong>
            </div>
            {product.ren_profile_conditions?.[info.rentacar?.typology]?.[
              info.language
            ]?.length > 0
              ? product.ren_profile_conditions?.[info.rentacar?.typology]?.[
                  info.language
                ]
              : info.t("noConditionsDefined")}
          </div>
        ) : (
          <div>
            <Divider></Divider>
            <div style={{ display: "flex", alignItems: "center" }}>
              <AiOutlineWarning size={20} />
              <div style={{ marginLeft: 10 }}>
                {info?.t("selectProfileForConditions")}
              </div>
            </div>
          </div>
        )}
        {/* {info.rentacar?.typology &&
          product.ren_profile_conditions &&
          Object.keys(product.ren_profile_conditions).length > 0 && (
            <Conditions
              conditions={
                product.ren_profile_conditions?.[info.rentacar?.typology]
              }
              typology={info.rentacar?.typology}
            />
          )} */}
      </div>
    </ItemInfoWrapper>
  );
}

export default RentacarInfo;
